<div class="log-container">
  <br>
  <!-- Título y botones -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h4>Logs: {{ activeSource }}</h4>
    <div>
      <button class="btn btn-sm btn-danger me-2" (click)="clearLogs()">Limpiar</button>
      <button class="btn btn-sm btn-success" (click)="downloadLog()">Descargar</button>
    </div>
  </div>

  <!-- Selector de fuente de log -->
  <div class="mb-3">
    <label class="me-2 fw-bold" for="logSelector">Selecciona log: </label>
    <select id="logSelector" class="form-select form-select-sm w-auto d-inline-block"
            [(ngModel)]="activeSource" (change)="onSourceChange(activeSource)">
      <option *ngFor="let source of logSources" [value]="source">{{ source }}</option>
    </select>
  </div>

  <!-- Filtros por tipo -->
  <div class="mb-3">
    <label class="me-2 fw-bold">Filtrar por tipo:</label>

    <div class="form-check form-check-inline" *ngFor="let item of filterKeys">
      <input
        class="form-check-input"
        type="checkbox"
        [id]="'filter-' + item.key.toLowerCase()"
        [(ngModel)]="filters[item.key]"
      />
      <label
        class="form-check-label"
        [ngClass]="'log-' + item.key.toLowerCase()"
        [for]="'filter-' + item.key.toLowerCase()">
        {{ item.label }}
      </label>
    </div>
  </div>


  <div class="mb-2">
    <small class="text-muted">
      Mostrando {{ getFilteredLogs().length }} línea{{ getFilteredLogs().length !== 1 ? 's' : '' }}
    </small>
  </div>

  <!-- Visualización del log -->
  <div class="log-box">
    <div *ngFor="let line of getFilteredLogs()" [ngClass]="getLogLevelClass(line)">
      {{ line }}
    </div>
  </div>
</div>
